import { PlaybookType as fsdbPlaybookType } from '@guidde/common-types/fsdb'

export type PlaybookTeamsType = {
    id: string
    name: string
}

export type PlaybookApplicationType = {
    applicationId: string
    applicationName: string
}

export type PlaybookTranscriptLanguageType =
    | 'de-DE'
    | 'es-ES'
    | 'it-IT'
    | 'fr-FR'
    | 'iw-IL'
    | 'pt-BR'
    | 'en-US'
    | 'en-AU'
    | 'en-GB'
    | 'en-CA'
    | 'en-IN'
    | 'en-IE'
    | 'en-ZA'

export type PlaybookSlicingSuggestionType = {
    applications: Array<string>
    duration: number
    end: number
    start: number
    tags: Array<string>
    thumbnail: string
}

export type PlaybookFileType = {
    id: string
    name: string
    uid: string
    url: string
}

export type PlaybookLinkType = {
    id: string
    name: string
    uid: string
    url: string
}

export type PlaybookPublishedForUserType = {
    displayName: string
    email: string
    photoURL: string
    uid: string
}

export type PlaybookVisibilityType = 'Private' | 'Team' | 'Connected' | 'Public'

export const enum PlaybookMode {
    Playbook = 'playbook',
    Playlist = 'playlist',
    QuickGuidde = 'quickGuidde',
}

export type PlaybookModeType = `${PlaybookMode}`
export type PlaybookType = {
    url: string
    screenshotUrl: string
    organizationId: string
    creator_uid: string
    duration: number
    id: string
    username?: string
    userImage?: string
    uploadedAt?: number
    title: string
    description?: string
    tags: Array<string>
    isPublished: boolean
    type: 'zoom' | 'manual'
    isPlaylist: boolean
    playbookList?: Array<string>
    gifUrl: string
    link?: string | null
    teams?: Array<PlaybookTeamsType>
    views: number
    applications: Array<PlaybookApplicationType>
    originalFileName: string
    rating: number
    transcript: any //@TODO: check type later
    transcriptUrl: string
    currentTranscriptLang: PlaybookTranscriptLanguageType
    slicingSuggestion?: Array<PlaybookSlicingSuggestionType>
    files?: Array<PlaybookFileType> | null
    links?: Array<PlaybookLinkType> | null
    isMainIncluded: boolean
    publishedForUsers?: Array<PlaybookPublishedForUserType>
    visibility: PlaybookVisibilityType
    uploadedByOrgId: string
    orgName: string
    isPublic: boolean
    spaceGroups?: Array<string> | null
    coverColor: string
    mode: PlaybookModeType
    steps: Array<any>
}

export type PlaybookBeforeUpload = {
    uid: string
    action: string
    playbookId: string
    data: Partial<fsdbPlaybookType>
}
